import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export const MessageBox: React.FC<{
  variant?: 'error' | 'success' | 'warning'
  containerClassName?: string
  contentClassName?: string
  children: ReactNode
}> = ({
  children,
  contentClassName,
  containerClassName,
  variant = 'error',
}) => (
  <div className={twMerge('flex justify-center my-4', containerClassName)}>
    <p
      className={twMerge(
        `rounded-2xl py-2 px-6 text-center ${
          variant === 'error'
            ? 'bg-red-600'
            : variant === 'success'
            ? 'bg-green-500'
            : 'bg-yellow-600'
        } text-white font-bold`,
        contentClassName
      )}
    >
      {children}
    </p>
  </div>
)
